import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  GetCategoryArticle,
  GetSignataire,
  GetExternalDepartment,
  GetProvinceRecipeTree,
  SaveArticleProperties,
} from "../api/memoHebdo.api";
import EmplacementTree from "../../../components/Common/Components/EmplacementTree";

import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Chip,
  Typography,
  Divider,
  Paper,
  Stack,
  Autocomplete,
  Snackbar,
  Alert,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import DrawRoundedIcon from "@mui/icons-material/DrawRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

function ArticleProperties({ open, onClose, article, onSaved }) {
  const userState = useSelector((state) => state.user);
  const { t } = useTranslation(["memohebdo"]);
  const initialState = {
    publicationDate: "",
    endPublicationDate: "",

    signatory: null,
    category: null,
    restaurants: [],
    readers: [],
  };

  const [form, setForm] = useState(initialState);
  const [categories, setCategories] = useState([]);
  const [signataires, setSignataires] = useState([]);
  const [idSignataire, setIdSignataire] = useState(null);
  const [signataire, setSignataire] = useState(null);
  const [externalDepartments, setExternalDepartments] = useState([]);
  const [provinceTree, setProvinceTree] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!article) return;

    setForm((prev) => ({
      ...prev,
      publicationDate: article.publicationDate
        ? article.publicationDate.split("T")[0]
        : "",
      endPublicationDate: article.endPublicationDate
        ? article.endPublicationDate.split("T")[0]
        : "",
      readers: article.idExternalDepartment || [],
      restaurants: article.idEmplacement || [], // <-- ajout important
    }));

    setSignataire(article.signataire?.userName || null);
    setIdSignataire(article.signataire?.noEmploye || null);
  }, [article]);

  const handleReset = () => {
    setForm(initialState);
  };

  /*Category ies article  */
  useEffect(() => {
    const loadSignataires = async () => {
      try {
        const data = await GetSignataire(userState.token);

        setSignataires(data || []);

        const selectedSignataire = data.find(
          (s) => Number(s.noEmploye) === Number(article?.idSignataire),
        );

        if (selectedSignataire) {
          setSignataire(selectedSignataire.userName);
          setIdSignataire(selectedSignataire.noEmploye);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (open && article) {
      loadSignataires();
    }
  }, [open, article, userState.token]);

  /*---------GetCategoryArticle-------*/
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await GetCategoryArticle(userState.token);

        setCategories(data || []);

        const selectedCategory = (data || []).find(
          (c) => Number(c.id) === Number(article?.idCategory),
        );

        setForm((prev) => ({
          ...prev,
          category: selectedCategory || null,
        }));
      } catch (error) {
        console.error(error);
      }
    };

    if (open && article) {
      loadCategories();
    }
  }, [open, article, userState.token]);

  /*-----handle Save */
  const handleSave = async () => {
    try {
      setSaving(true);

      const payload = {
        id: article.id,
        idCategory: form.category?.id || 0,
        idSignatory: idSignataire || 0,
        publicationDate: form.publicationDate || null,
        endPublicationDate: form.endPublicationDate || null,
        idExternalDepartment: form.readers || [],
        idEmplacement: form.restaurants || [],
      };

      const response = await SaveArticleProperties(userState.token, payload);

      // ✅ SUCCESS (HTTP 200)
      onSaved?.({
        success: true,
        message: response?.message || "Saved successfully",
      });

      onClose();
    } catch (error) {
      console.log("SAVE ERROR:", error);

      // ❌ ERROR (HTTP 400 / 500)
      const msg =
        error?.data?.message || // 👈 IMPORTANT (fetch custom error)
        error?.message ||
        "Une erreur est survenue";

      onSaved?.({
        success: false,
        message: msg,
      });
    } finally {
      setSaving(false);
    }
  };
  /*---------Charger les départements-------*/
  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const data = await GetExternalDepartment(userState.token);

        setExternalDepartments(data || []);
      } catch (error) {
        console.error(error);
      }
    };

    if (open) {
      loadDepartments();
    }
  }, [open, userState.token]);

  /*---------Charger les provinces-------*/
  useEffect(() => {
    const loadProvinceTree = async () => {
      try {
        const data = await GetProvinceRecipeTree(userState.token);

        setProvinceTree(data || []);

        console.log("Province Tree", data);
      } catch (error) {
        console.error(error);
      }
    };
    if (open) {
      loadProvinceTree();
    }
  }, [open, userState.token]);

  // ICI 👇 test log

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: 5,
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}

      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            background: "linear-gradient(135deg, #f9a825, #ffca28)",
            color: "white",
            px: 4,
            py: 3,
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <SettingsRoundedIcon
              sx={{
                fontSize: 34,
              }}
            />

            <Box>
              <Typography fontWeight={800} fontSize={24}>
                {t("memoHebdo.propertiesDialog.title")}
              </Typography>

              <Typography
                fontSize={13}
                sx={{
                  opacity: 0.9,
                }}
              >
                {t("memoHebdo.propertiesDialog.subtitle")}
              </Typography>

              <Typography
                fontSize={12}
                sx={{
                  opacity: 0.8,
                  mt: 0.5,
                }}
              >
                {t("memoHebdo.propertiesDialog.articleId")} :{article?.id}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </DialogTitle>

      {/* CONTENT */}

      <DialogContent
        sx={{
          p: 4,
          background: "#f8fafc",
        }}
      >
        <Grid container spacing={3}>
          {/* PUBLICATION */}

          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #e5e7eb",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <EventRoundedIcon color="primary" />

                <Typography fontWeight={800} fontSize={18}>
                  {t("memoHebdo.propertiesDialog.sections.publication")}
                </Typography>
              </Stack>

              <Divider
                sx={{
                  mb: 3,
                }}
              />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={t(
                      "memoHebdo.propertiesDialog.fields.publicationDate",
                    )}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={form.publicationDate}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        publicationDate: e.target.value,
                      }))
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={t(
                      "memoHebdo.propertiesDialog.fields.endPublicationDate",
                    )}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={form.endPublicationDate}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        endPublicationDate: e.target.value,
                      }))
                    }
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* SIGNATORY */}

          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <DrawRoundedIcon color="primary" />

                <Typography fontWeight={800} fontSize={18}>
                  {t("memoHebdo.propertiesDialog.sections.signatory")}
                </Typography>
              </Stack>

              <Divider
                sx={{
                  mb: 3,
                }}
              />
              <Autocomplete
                disablePortal
                options={signataires}
                getOptionLabel={(s) =>
                  `${s.name} ${s.lastName} (${s.userName})`
                }
                value={
                  signataires.find(
                    (s) => Number(s.noEmploye) === Number(idSignataire),
                  ) || null
                }
                onChange={(event, newValue) => {
                  setSignataire(newValue?.userName || null);
                  setIdSignataire(newValue?.noEmploye || null);

                  setForm((prev) => ({
                    ...prev,
                    signatory: newValue || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("memoHebdo.propertiesDialog.fields.signatory")}
                  />
                )}
              />
            </Paper>
          </Grid>

          {/* CATEGORY */}

          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <CategoryRoundedIcon color="primary" />

                <Typography fontWeight={800} fontSize={18}>
                  {t("memoHebdo.propertiesDialog.sections.category")}
                </Typography>
              </Stack>

              <Divider
                sx={{
                  mb: 3,
                }}
              />

              <Autocomplete
                options={categories}
                value={form.category}
                onChange={(_, value) =>
                  setForm((prev) => ({
                    ...prev,
                    category: value,
                  }))
                }
                getOptionLabel={(option) =>
                  userState.lang === "FR"
                    ? option?.textFr || option?.TextFr || ""
                    : option?.textEn || option?.TextEn || ""
                }
                isOptionEqualToValue={(option, value) =>
                  (option?.id || option?.Id) === (value?.id || value?.Id)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t(
                      "memoHebdo.propertiesDialog.fields.selectCategory",
                    )}
                  />
                )}
              />
            </Paper>
          </Grid>
          {/* READERS */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #e5e7eb",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <PeopleAltRoundedIcon color="primary" />

                <Typography fontWeight={800} fontSize={18}>
                  {t("memoHebdo.propertiesDialog.sections.readers")}
                </Typography>
              </Stack>

              <Divider sx={{ mb: 2 }} />

              <Box
                sx={{
                  flex: 1,
                  maxHeight: 500,
                  overflowY: "auto",
                }}
              >
                <FormGroup
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                  }}
                >
                  {externalDepartments.map((dept) => {
                    const checked = form.readers.includes(dept.id);

                    return (
                      <FormControlLabel
                        key={dept.id}
                        control={
                          <Checkbox
                            checked={checked}
                            sx={{
                              color: "#f9a825",
                              "&.Mui-checked": {
                                color: "#f9a825",
                              },
                            }}
                            onChange={() => {
                              setForm((prev) => {
                                const exists = prev.readers.includes(dept.id);

                                return {
                                  ...prev,
                                  readers: exists
                                    ? prev.readers.filter((x) => x !== dept.id)
                                    : [...prev.readers, dept.id],
                                };
                              });
                            }}
                          />
                        }
                        label={
                          userState.lang === "FR" ? dept.textFr : dept.textEn
                        }
                      />
                    );
                  })}
                </FormGroup>
              </Box>

              {form.readers.length > 0 && (
                <Box mt={2}>
                  <Typography variant="body2" fontWeight={700} sx={{ mb: 1 }}>
                    {t("memoHebdo.propertiesDialog.selectedDepartments")}
                  </Typography>

                  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    {externalDepartments
                      .filter((d) => form.readers.includes(d.id))
                      .map((d) => (
                        <Chip
                          key={d.id}
                          label={userState.lang === "FR" ? d.textFr : d.textEn}
                          sx={{
                            backgroundColor: "#f9a825",
                            color: "#fff",
                            fontWeight: 600,
                          }}
                        />
                      ))}
                  </Stack>
                </Box>
              )}
            </Paper>
          </Grid>

          {/* RESTAURANTS */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #e5e7eb",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <RestaurantRoundedIcon color="primary" />

                <Typography fontWeight={800} fontSize={18}>
                  {t("memoHebdo.propertiesDialog.sections.restaurants")}
                </Typography>
              </Stack>

              <Divider sx={{ mb: 2 }} />

              <Box
                sx={{
                  flex: 1,
                  maxHeight: 500,
                  overflowY: "auto",
                }}
              >
                <EmplacementTree
                  data={provinceTree}
                  language={userState.lang === "FR" ? "fr" : "en"}
                  selectedIds={form.restaurants}
                  onChange={(selectedIds) => {
                    setForm((prev) => ({
                      ...prev,
                      restaurants: selectedIds,
                    }));
                  }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions
        sx={{
          p: 3,
          borderTop: "1px solid #e5e7eb",
          justifyContent: "space-between",
        }}
      >
        <Button startIcon={<RestartAltRoundedIcon />} onClick={handleReset}>
          {t("memoHebdo.propertiesDialog.buttons.reset")}
        </Button>

        <Box
          sx={{
            display: "flex",
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<CloseRoundedIcon />}
            onClick={onClose}
          >
            {t("memoHebdo.propertiesDialog.buttons.cancel")}
          </Button>

          <Button
            variant="contained"
            startIcon={<SaveRoundedIcon />}
            onClick={handleSave}
            disabled={saving}
          >
            {saving
              ? t("memoHebdo.propertiesDialog.buttons.saving")
              : t("memoHebdo.propertiesDialog.buttons.save")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
export default ArticleProperties;
